// extracted by mini-css-extract-plugin
export default {"metadata":"styles__metadata___eP8Y7","metadatum":"styles__metadatum___nc6y9"};